import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=f2bd3d1e&scoped=true&lang=pug&"
import script from "./PageFooter.vue?vue&type=script&lang=ts&"
export * from "./PageFooter.vue?vue&type=script&lang=ts&"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=f2bd3d1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bd3d1e",
  null
  
)

export default component.exports